export default "__VITE_ASSET__BY$hzEYl__"